<template>
  <div class="personels">
    <div v-if="personels.length > 0">
      <v-data-table
        dense
        :disable-sort="true"
        :headers="headers"
        hide-default-footer
        disable-pagination
        :items="personels"
        item-key="MessageId"
        group-by="Section"
      >
        <template v-slot:group.header="{ items, isOpen, toggle }">
          <th class="group-header" :colspan="headers.length">
            <div class="d-flex" @click="toggle">
              <v-checkbox
                dense
                hide-details=""
                @change="selectGroup($event, items[0].Section)"
                class="ma-0 pa-0"
              ></v-checkbox>
              <span>{{ items[0].Section }}</span>
              <v-spacer></v-spacer>

              <v-icon
                >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
              </v-icon>
            </div>
          </th>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td>
              <v-checkbox
                dense
                hide-details=""
                v-model="item.selected"
                class="ma-0 pa-0"
              ></v-checkbox>
            </td>
            <td>{{ item.PERNO }}</td>
            <td>{{ item.PersonName }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <eos-dialog ref="dialog" />
  </div>
</template>

<script>
export default {
  props: { personels: Array },
  data() {
    return {
      groupMessages: [],
      expanded: [],
      singleExpand: false,
      headers: [
        {
          text: "",
          value: "select",
        },
        {
          text: this.$t("card-no"),
          value: "PERNO",
        },
        {
          text: this.$t("person-name"),
          value: "PersonName",
        },
      ],
    };
  },
  mounted() {
    this.personels.forEach((element) => {
      element.selected = false;
    });
  },
  methods: {
    selectGroup(s, section) {
      this.personels.forEach(element => {
        if (element.Section === section) {
          //console.log(s);

          element.selected = s;
        }
      });
    },
  },
};
</script>

<style scoped>
.group-header {
  background: #ededed !important;
}
</style>